<nav class="bg-nav-gradient shadow-lg">
  <div class="mx-auto px-4">
    <div class="flex justify-between items-center">
      <div>
        <a href="/" class="flex items-center py-4 gap-2 md:gap-4">
          <img src="assets/images/mli-logo.svg" alt="MLI Logo" class="h-12 md:h-16" />
          <img
            src="/assets/images/mli-header.svg"
            alt="MLI Header"
            class="h-9 md:h-11 lg:h-12 ml-2 md:ml-4"
          />
        </a>
      </div>

      <div class="hidden md:flex items-center md:space-x-3 lg:space-x-5 xl:space-x-6">
        <a
          href="/"
          class="py-3 md:px-1 lg:px-2 text-white hover:text-white hover:bg-white/10 rounded-md font-medium transition duration-300"
          >All Courses</a
        >

        <a
          [routerLink]="'/live'"
          class="py-3 md:px-1 lg:px-2 text-white hover:text-white hover:bg-white/10 rounded-md font-medium transition duration-300 flex items-center"
        >
          <span class="relative mr-1.5 flex h-3 w-3">
            <span
              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"
            ></span>
            <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
          </span>
          Live
        </a>

        <a
          href="https://www.mlieducation.org/about-us/"
          target="_blank"
          class="py-3 md:px-1 lg:px-2 text-white hover:text-white hover:bg-white/10 rounded-md font-medium transition duration-300"
          >About MLI</a
        >

        <div
          *ngIf="isLoggedIn"
          class="relative"
          id="account-dropdown-container"
          (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()"
        >
          <button
            id="account-dropdown-toggle"
            (click)="onToggleClick($event)"
            class="py-3 md:px-1 lg:px-2 text-white rounded-md font-medium transition duration-300 flex items-center"
          >
            <span class="flex items-center">
              <span class="bg-white/20 rounded-full p-1 mr-2">
                <svg
                  class="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </span>
              My Account
              <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </span>
          </button>
          <div
            id="account-dropdown-menu"
            [class.hidden]="!isDropdownOpen"
            class="absolute right-0 mt-0 w-72 bg-white rounded-md shadow-xl pt-1 z-50 hidden transform transition-all duration-300 ease-in-out"
          >
            <div class="px-4 py-2 border-b border-gray-100">
              <p class="text-xs text-gray-500 italic mb-1">Signed in as:</p>
              <p class="font-medium text-gray-800 mb-1">{{ userName }}</p>
            </div>
            <a
              *ngIf="!isGuestUser"
              [routerLink]="'/my-account/update-profile'"
              class="flex items-center px-4 py-2 text-gray-800 hover:bg-primary-50 hover:text-primary-700 transition duration-200"
            >
              <svg
                class="w-4 h-4 mr-3 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                ></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                ></path>
              </svg>
              Account Details
            </a>
            <a
              *ngIf="!isGuestUser"
              [routerLink]="'/my-account/courses'"
              class="flex items-center px-4 py-2 text-gray-800 hover:bg-primary-50 hover:text-primary-700 transition duration-200"
            >
              <svg
                class="w-4 h-4 mr-3 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                ></path>
              </svg>
              My Courses
            </a>
            <div class="border-t border-gray-100 my-0"></div>
            <button
              *ngIf="!isGuestUser"
              (click)="logout()"
              class="w-full flex items-center px-4 py-2 rounded-b-md text-red-600 hover:bg-red-100 transition duration-200"
            >
              <svg
                class="w-4 h-4 mr-3 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                ></path>
              </svg>
              Logout
            </button>
          </div>
        </div>

        <div *ngIf="!isLoggedIn" class="flex items-center space-x-3">
          <a
            [routerLink]="'/auth/login'"
            class="py-3 md:px-1 lg:px-2 text-white hover:text-white hover:bg-white/10 rounded-md font-medium transition duration-300 flex items-center mr-2"
            >Login</a
          >
          <a
            [routerLink]="'/auth/register'"
            class="py-2 md:px-3 lg:px-5 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition duration-300 font-medium shadow-lg hover:shadow-xl"
            >Get Started</a
          >
        </div>
      </div>

      <div class="md:hidden flex items-center">
        <button class="mobile-menu-button outline-none" (click)="toggleMobileMenu()">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              class="mobile-menu-icon"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <div
      class="mobile-menu hidden md:hidden fixed inset-0 bg-nav-gradient z-50 flex flex-col overflow-y-auto"
    >
      <div class="flex justify-between items-center p-4 border-b border-white/20">
        <a href="/" class="flex items-center gap-2">
          <img src="assets/images/mli-logo.svg" alt="MLI Logo" class="h-10" />
          <img src="assets/images/mli-header.svg" alt="MLI Header" class="h-8 ml-2" />
        </a>
        <button class="outline-none" (click)="toggleMobileMenu()">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>

      <div class="flex-1 p-6 space-y-6">
        <div *ngIf="isLoggedIn" class="mb-8 pb-4 border-b border-white/20">
          <div class="flex items-center space-x-3">
            <div class="bg-white/20 rounded-full p-3">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                ></path>
              </svg>
            </div>
            <div>
              <p class="text-white text-sm opacity-80">Welcome back,</p>
              <p class="text-white font-medium">User</p>
            </div>
          </div>
        </div>

        <div class="space-y-3">
          <a
            href="/"
            class="block py-3 px-4 text-white text-lg font-medium hover:bg-white/10 rounded-lg transition duration-300"
            >Home</a
          >
          <a
            href="/"
            class="block py-3 px-4 text-white text-lg font-medium hover:bg-white/10 rounded-lg transition duration-300"
            >About MLI</a
          >
          <a
            href="/"
            class="block py-3 px-4 text-white text-lg font-medium hover:bg-white/10 rounded-lg transition duration-300"
            >All Courses</a
          >
          <a
            [routerLink]="'/live'"
            class="flex items-center py-3 px-4 text-white text-lg font-medium hover:bg-white/10 rounded-lg transition duration-300"
          >
            <span class="relative mr-3 flex h-3 w-3">
              <span
                class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"
              ></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
            </span>
            Live
          </a>
        </div>

        <div
          *ngIf="isLoggedIn && !isGuestUser"
          class="mt-8 pt-4 border-t border-white/20 space-y-4"
        >
          <p class="text-white text-lg font-medium px-4">My Account</p>
          <a
            [routerLink]="'/my-account/update-profile'"
            (click)="toggleMobileMenu()"
            class="flex items-center py-3 px-4 text-white hover:bg-white/10 rounded-lg transition duration-300"
          >
            <svg
              class="w-5 h-5 mr-3 text-white/70"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              ></path>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              ></path>
            </svg>
            Account Details
          </a>
          <a
            [routerLink]="'/my-account/courses'"
            (click)="toggleMobileMenu()"
            class="flex items-center py-3 px-4 text-white hover:bg-white/10 rounded-lg transition duration-300"
          >
            <svg
              class="w-5 h-5 mr-3 text-white/70"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
              ></path>
            </svg>
            My Courses
          </a>
        </div>
        <div class="p-6 border-t border-white/20">
          <button
            *ngIf="isLoggedIn && !isGuestUser"
            (click)="logout()"
            class="flex items-center justify-center py-3 px-4 bg-red-600 text-white rounded-lg hover:bg-red-700 hover:rounded-lg transition duration-300"
          >
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              ></path>
            </svg>
            Logout
          </button>
          <div *ngIf="!isLoggedIn" class="flex flex-col space-y-3">
            <a
              [routerLink]="'/auth/login'"
              class="py-3 px-4 border border-white text-white rounded-lg text-center hover:bg-white/10 transition duration-300"
              >Login</a
            >
            <a
              [routerLink]="'/auth/register'"
              class="py-3 px-4 bg-blue-600 text-white rounded-lg text-center font-medium shadow-lg hover:shadow-xl hover:bg-blue-700 transform hover:-translate-y-0.5 transition duration-300"
              >Get Started</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
